<div class="div_loading">
    <div class="my-container" [hidden]="!loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>
<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div mat-dialog-title class="matDialogTitle" cdkDragHandle>
        <span>
            <span>ثبت پرداخت</span>
        </span>
        <span (click)="close()">
            <mat-icon class="close">close</mat-icon>
        </span>
    </div>


    <form [formGroup]="form1_group" (ngSubmit)="check_access(type_task,1)">
        <div mat-dialog-content class="matDialogContent">
            <div class="row pe1">
                <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                    <label for="title" class='wh-label'>
                        <span *ngIf="lang == 1"> عنوان تراکنش : </span>
                        <span *ngIf="lang == 2"> Title : </span>
                        <input class='wh-input' formControlName="title" autocomplete="off">
                    </label>
                </div>

                <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                    <label for="payment" class='wh-label'>
                        <span *ngIf="lang == 1"> مبلغ : </span>
                        <span *ngIf="lang == 2"> Payment : </span>
                        <input class='wh-input' formControlName="payment" currencyMask autocomplete="off">
                    </label>
                </div>

                <div class='col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                    style="margin-top:15px">
                    <mat-label class="wh-label">تاریخ تراکنش:
                        <input class="wh-input" matInput [matDatepicker]="picker" formControlName="date3"
                            (dateChange)="change_start_date()" autocomplete="off" style="padding-right:4px">
                        <mat-datepicker-toggle matSuffix [for]="picker" class="datepicker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-label>
                </div>



                <div class='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                    <label for="comment" class='wh-label'>
                        <span *ngIf="lang == 1"> توضیحات : </span>
                        <span *ngIf="lang == 2"> Comment : </span>
                        <textarea style="height:5rem" class='wh-input' formControlName="comment" autocomplete="off">
                    </textarea>
                    </label>
                </div>
            </div>


            <div class="row">
                <div class="container1">
                    <div class="row file">
                        <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12" style='margin-bottom:14px'>
                            <div class='pe'>
                                <span>فایل ها :</span>
                                <span style='color:#666;font-size:11px'>برای آپلود فایل خود یا روی باکس پایین کلیک کنید
                                    و یا فایل خود را
                                    به
                                    باکس پایین بکشید</span>
                                <span>و برای فعال سازی سایر تنطیمات روی آیکن مقابل کلیک نمائید.</span>
                                <span (click)="load_file(2)" style='cursor:pointer'> <i class="fas fa-cogs"></i>
                                </span>
                            </div>
                        </div><!-- col-md-12 col-lg-12 col-sm-12 col-xs-12 -->
                        <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12"
                            style="max-height:400px;overflow-y: auto;text-align: center;padding:0;">
                            <form [dropzone]="config" class="dropzone dz-started" id="my-awesome-dropzone">
                                <input type="" name="username" value="{{ user_id }}" style="display:none">
                                <input type="" name="code" value="{{ id }}" style="display:none">
                                <input type="" name="type" value="{{ 11 }}" style="display:none">
                                <input type="" name="site" value="{{ site }}" style="display:none">

                                <div class="dz-preview dz-processing dz-image-preview dz-success dz-complete box box-right"
                                    *ngFor="let file of list_load_file;let i = index"
                                    (onBeforeMenuOpen)="onBefore(i,$event,file.user_file_id,file.user_file_title)"
                                    [sh-context]="itemsRtl" [sh-data-context]="dataCtxOne" [sh-options]="options">
                                    <div class="dz-image">
                                        <a href='{{ file.sale_payments_attach_site }}/{{ file.sale_payments_attach_file }}'
                                            target="_blank">
                                            <span
                                                *ngIf="file.sale_payments_attach_type == 'image/jpeg' || file.sale_payments_attach_type == 'image/gif' ||  file.sale_payments_attach_type == 'image/png' ">
                                                <img data-dz-thumbnail="" alt="{{ file.user_file_title }}"
                                                    src="{{ file.sale_payments_attach_site }}/{{ file.sale_payments_attach_file }}"
                                                    style="max-width:200px !important;width:200px !important">
                                            </span>
                                            <span
                                                *ngIf="file.sale_payments_attach_type == 'application/msword' || file.sale_payments_attach_type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ">
                                                <i class="far fa-file-word icone"></i>
                                            </span>
                                            <span
                                                *ngIf="file.sale_payments_attach_type == 'application/vnd.ms-excel' || file.sale_payments_attach_type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ">
                                                <i class="fas fa-file-excel icone" style='color:green'></i>
                                            </span>
                                            <span *ngIf="file.sale_payments_attach_type == 'application/pdf' ">
                                                <i class="far fa-file-pdf icone" style='color:red'></i>
                                            </span>
                                            <span *ngIf="file.sale_payments_attach_type == 'application/zip' ">
                                                <i class="fas fa-file-archive icone"></i>
                                            </span>
                                            <span
                                                *ngIf="file.sale_payments_attach_type == 'video/mp4' || file.sale_payments_attach_type == 'video/x-matroska';else other ">
                                                <i class="fas fa-file-video icone" style='color:black'></i>
                                            </span>
                                            <ng-template #other>
                                                <i class="fas fa-file-alt icone" style='color:black'></i>
                                            </ng-template>
                                        </a>
                                    </div><!-- dz-image -->
                                    <div class="dz-details">
                                        <div style="display:inline;float:left">
                                            <span (click)="delete_file(i,file.sale_payments_attach_id)">
                                                <i class="material-icons icon"
                                                    style='font-size:1.2rem'>delete_forever</i>
                                            </span>
                                        </div>
                                        <div class="dz-size">
                                            <span data-dz-size=""><strong>{{ file.user_attach_size }}</strong>
                                                KB</span>
                                        </div><!-- dz-size-->
                                        <div class="dz-filename">
                                            <span data-dz-name="" class="pe1"></span>
                                        </div><!-- dz-filename-->
                                    </div> <!-- dz-detaile-->
                                    <div class="dz-progress">
                                        <span class="dz-upload" data-dz-uploadprogress="" style="width: 100%;"></span>
                                    </div><!-- dz-progress -->

                                </div><!-- dz-preview dz-processing dz-image-preview dz-success dz-complete -->
                            </form><!-- dropzone dz-started -->
                        </div><!-- col-md-12 -->
                    </div><!-- row file -->
                </div>
            </div>

        </div><!-- content -->

        <div mat-dialog-actions class="matDialogActions">
            <button type="submit" [disabled]="!form1_group.valid" class="btn_pe" [ngClass]="{btn_en:lang == 2}"
                *ngIf="type_task == 1 || type_task == 2">
                <span *ngIf="lang == 2">Save</span>
                <span *ngIf="lang == 1">ذخیره</span>
            </button>
            <button type="submit" class="btn_pe" [ngClass]="{btn_en:lang == 2}" *ngIf="type_task == 3">
                <span *ngIf="lang == 2">Search</span>
                <span *ngIf="lang == 1">جستجو</span>
            </button>
            <button type="button" class="btn_pe" [ngClass]="{btn_en:lang == 2}" *ngIf="type_task == 3"
                (click)="check_access(type_task,2)">
                <span *ngIf="lang == 2">Excel</span>
                <span *ngIf="lang == 1">خروجی اکسل</span>
            </button>


        </div>
    </form>
</div>